import { AddRounded, RemoveRounded } from '@mui/icons-material';
import { Accordion, AccordionDetails } from '@mui/material';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { useDispatch } from 'react-redux';

import ProjectLink from '../Project/ProjectLink';
import { CustomAccordion, Parent, Tree } from '@/components/ui/Tree/CustomAccordion';

const classList = ['.btn-action', '.MuiBackdrop-root'];

export default function FileRow({ project, idx = 0, currOpen = false, lastChild = false, setLastChild = () => {}, type = 'child' }) {
	const dispatch = useDispatch();
	const [open, setOpen] = useState(false);
	const [lastChildOpen, setLastChildOpen] = useState(false);
	const a = idx > 0 ? 0.5 : 0;

	const icon = project.icon || project.component_prefix_icon;
	const isIcon = icon && icon !== 'No icon';
	const prefix = project.productprefix || project.component_prefix_name;
	const codeNumber = project.productcodenumber || project.component_code_number;
	const pType = <strong>{`${prefix} ${codeNumber}`}</strong>;
	const pName = `${project.productname || project.component_productname}`;
	const articles = project.article?.filter((a) => a.articlenumber)?.map((a) => a.articlenumber) || [];
	const refArticles = project.referencerelation?.filter((a) => a.reference_detail)?.map((a) => a.reference_detail) || [];
	const dt = new Date(project.updatetimestamp);

	const isChild = type === 'child';
	const isSearch = type === 'search';
	const pRel = project.projectrelations;
	const rel = pRel?.length;
	let lastRel = 0;
	if (idx === 0 && rel) {
		if (isChild) {
			lastRel = pRel[rel - 1]?.projectrelations?.length || 0;
		} else if (!isSearch) {
			lastRel = pRel[rel - 1]?.parent_projectrelations?.length || 0;
		} else {
			lastRel = pRel[rel - 1]?.projectrelations?.length || 0;
		}
	}
	const deduction = lastChildOpen && lastRel ? lastRel * 64 : 0;

	const onRowClick = () => {
		dispatch({
			type: 'trigger/triggerAPI',
			payload: {
				key: 'showPublicDetail',
				value: {
					name: pName,
					type: prefix,
					number: codeNumber,
					date: dt,
					article: articles.concat(refArticles),
				},
			},
		});
	};
	return rel > 0 ? (
		<Accordion
			className={twMerge('w-full', open && lastChild ? 'acc-last' : '')}
			defaultExpanded={idx === 0}
			expanded={idx === 0 ? true : open}
			onChange={(e) => {
				const isAction = e.target?.matches(classList) || e.target?.closest('button')?.matches(classList);
				if (isAction) return;
				const status = !open;
				if (lastChild) {
					setLastChild(status);
				}
				setOpen(status);
			}}
		>
			<CustomAccordion
				expandIcon={
					!open ? (
						<div className='border-2 rounded-sm w-auto h-auto flex items-center justify-center p-[1px]'>
							<AddRounded fontSize='' />
						</div>
					) : (
						<div className='border-2 rounded-sm w-auto h-auto flex items-center justify-center p-[1px]'>
							<RemoveRounded fontSize='' />
						</div>
					)
				}
				className={twMerge('w-full border-y')}
				sx={{
					'& > .MuiAccordionSummary-expandIconWrapper': {
						position: 'absolute',
						left: `${0.75 + a * idx + idx}rem`,
					},
				}}
			>
				<div className='grid w-full grid-cols-12'>
					<Tree
						size={idx === 0 ? 0 : 1}
						h={currOpen ? rel * 4 : 0}
						l={0.75 + a * idx + idx}
						style={{ paddingLeft: `${3 + a * idx + idx}rem` }}
						className={twMerge(`relative col-span-10 flex items-center gap-2`, `pl-12`)}
						open={currOpen}
						last_child={lastChild}
						last_child_open={lastChildOpen}
						type='file'
						onClick={onRowClick}
					>
						{isIcon && <img src={icon} className='w-7 h-7' />}
						{pType} &nbsp;
						{pName}
					</Tree>
					<div className='col-span-2 text-center'>
						<ProjectLink project={project} from='files' />
					</div>
				</div>
			</CustomAccordion>
			<AccordionDetails className=''>
				<Parent
					className={twMerge('w-full h-full', open ? 'open' : '')}
					size={idx === 0 ? 0 : 1}
					open={idx === 0 || open}
					// h={`${idx === 0 ? 'calc(100% - 44px - 32px)' : `${rel ? rel * 64 - 12 : 64}px`}`}
					h={`${idx === 0 ? `calc(100% - 44px - 32px - ${lastChildOpen ? deduction : 0}px)` : `${rel ? rel * 64 - 12 : 64}px`}`}
					l={0.75 + a * idx + idx}
					lastChildOpen={lastChildOpen}
					isLastChild={idx === 0}
					type='file'
				>
					{rel > 0 &&
						pRel.map((p, i) => (
							<FileRow
								key={JSON.stringify(p)}
								project={p}
								idx={idx + 1}
								open={idx === 0 || open}
								lastChild={i + 1 === +rel}
								setLastChild={setLastChildOpen}
								type={type}
							/>
						))}
				</Parent>
			</AccordionDetails>
		</Accordion>
	) : (
		<div className='grid items-center w-full h-16 grid-cols-12 border-y'>
			<Tree
				size={!rel && idx === 0 ? 0 : 2}
				l={0.75 + a * idx + idx}
				style={{ paddingLeft: `${3 + (a * idx + idx)}rem` }}
				className={twMerge(`relative col-span-10 flex items-center gap-2`)}
				type='file'
				onClick={onRowClick}
			>
				{isIcon && <img src={icon} className='w-7 h-7' />}
				{pType} &nbsp;
				{pName}
			</Tree>
			<div className='col-span-2 text-center'>
				<ProjectLink project={project} from='files' />
			</div>
		</div>
	);
}
